import { createContext, useContext } from "react";

import { TeamMemberWithOrganizationTeamMembers } from "~/common/utils";

export const CurrentTeamMemberContext =
  createContext<TeamMemberWithOrganizationTeamMembers | null>(null);

export const useCurrentTeamMemberContext = () => {
  const teamMember = useContext(CurrentTeamMemberContext);
  if (!teamMember)
    throw Error(
      "useCurrentTeamMemberContext must be used inside CurrentTeamMemberContext.Provider",
    );
  return teamMember;
};
